import VueAvatar from './VueAvatar'

export { VueAvatar }

export default VueAvatar
